export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lists.vue?vue&type=template&id=514a3113"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/games/lists.vue?vue&type=template&id=514a3113
// module id = yxMz
// module chunks = 0